<template>
    <div>
        <div class="card">
            <vue-good-table
                    ref="generic-table"
                    mode="remote"
                    styleClass="vgt-table striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    title="Lista eventi"
                    :columns="columns"
                    :rows="rows"
                    totalRecords
                    :paginate="true"
                    :lineNumbers="false"
                    :pagination-options="{
                                enabled: true,
                                position: 'top',
                                nextLabel: 'Successivo',
                                prevLabel: 'Precedente',
                                rowsPerPageLabel: 'Righe per pagina',
                                dropdownAllowAll: false,
                                perPage: serverParams.pagination.currentPerPage,
                                perPageDropdown: serverParams.myPerPageDropdown,
                                setCurrentPage: serverParams.pagination.currentPage
                    }"
                    :sort-options="{ enabled: true, }"
                    :selectOptions="{
                          enabled: entity_delete,
                          selectOnCheckboxOnly: true,
                          selectionInfoClass: 'generic-class',
                          selectionText: 'righe selezionate',
                          clearSelectionText: 'deseleziona',
                    }"
                    :isLoading="isLoading"
            >
                <div slot="emptystate" id="emptystate" v-if="totalRecords == 0">
                    <div class="vgt-center-align vgt-text-disabled">
                        <span v-if="!isLoading">Nessun risultato disponibile</span>
                    </div>
                </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'categoria'">
                      <multiselect-combo :selected="props.formattedRow[props.column.field]" :options="options" @change="(e) => saveEvent(props.formattedRow['id'], e, props.formattedRow['featured'])" ></multiselect-combo>
                    </span>
                    <span v-else-if="props.column.field == 'featured'">
                      <input type="checkbox" v-model="props.formattedRow['featured']"  @change="(e) => saveEvent(props.formattedRow['id'], props.formattedRow['category'] , e.target.checked)" />
                    </span>
                    <span v-else >{{props.formattedRow[props.column.field]}}</span>
                </template>
            </vue-good-table>
            <!-- chiusura componente -->
        </div>
    </div>
</template>

<script>
    import axios from "axios";


    import StatusesBox from "@/components/altrama/StatusesBox";
    import CityCombo from "@/components/altrama/CityCombo";
    import ProvinceCombo from "@/components/altrama/ProvinceCombo";
    import CategoryCombo from "@/components/altrama/CategoryBox";
    import SearchBox from "@/components/altrama/SearchBox";
    import StatusesSpan from "@/components/altrama/StatusesSpan";
    import LangBox from "@/components/altrama/LangBox";
    import DatePicker from "@/components/altrama/DatePicker";
    import LocalitaCombo from "@/components/altrama/LocalitaCombo";
    import MultiselectCombo from "@/components/altrama/MultiSelectBox";

    let moment = require("moment");
    const tableColumns = [];
    var tableData = [];
    var self = this;

    export default {
        components: {
            SearchBox,
            CategoryCombo,
            CityCombo,
            StatusesBox,
            ProvinceCombo,
            StatusesSpan,
            LangBox,
            DatePicker,
            LocalitaCombo,
            MultiselectCombo
        },
        data() {
            return {
              options: [
                "Villaggi del Natale",
                "Piste di Pattinaggio",
                "Concerti",
                "Spettacoli",
                "Presepi",
                "Arte",
                "Spettacoli Pirotecnici",
                "Experience",
                "Capodanno",
                "Iniziative speciali",
                "Mercatini",
                "Fuochi artificiali"
              ],
                showUpload: false,
                dropzoneOptions: {
                    url: this.$url + "attachments/upload",
                    thumbnailWidth: 150,
                    maxFilesize: 100,
                    headers:  this.$config.axiosHeadersUpload(),
                    addRemoveLinks: true
                },
                table1: {
                    title: "Elenco",
                    columns: [...tableColumns],
                    data: [...tableData],
                    route: "attachments"
                },
                columns: [
                    {
                        label: "ID",
                        field: "id",
                        type: "number",
                        html: false,
                        tdClass: "text-center",
                        thClass: "text-center"
                    },
                    {
                        label: "Nome",
                        field: "title",
                        sortable: false
                    },
                    {
                        label: "Comune",
                        field: "comune",
                        sortable: false
                    },
                    {
                        label: "Evidenza",
                        field: "featured",
                        sortable: false
                    },
                    {
                        label: "Categoria",
                        field: "categoria",
                        sortable: false
                    }
                ],
                entity_create: false,
                entity_delete: false,
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    pagination: {
                        currentPage: 1,
                        currentPerPage: 50
                    },
                    myPerPageDropdown: [10, 20, 30, 40, 50]
                },
                isLoading: false,
                searchQuery: {

                }
            };
        },

        created: async function () {
            if (await this.$api.user.can("media-view") == false) {
                this.$router.replace("/not-found");
                return;
            }
            this.entity_create = await this.$api.user.can( "media-create");
            this.entity_delete = await this.$api.user.can( "media-delete");
        },

        mounted: function () {
            if (localStorage.getItem('festivita_searchQuery')) { // parametri di ricerca
                this.searchQuery = this.getSearchFilter();
            }
            if (localStorage.getItem('festivita_serverParams')) { // parametri di tabella
                this.serverParams = this.getParameterFilter();
            }
            this.updateResource();
        },

        methods: {
            filter() {
                this.serverParams.pagination.currentPage = 1;
                this.updateResource();
            },

            noFilter() {
                localStorage.removeItem("festivita_searchQuery");
                localStorage.removeItem("festivita_serverParams");

                this.serverParams = {
                    columnFilters: {},
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    pagination: {
                        currentPage: 1,
                        currentPerPage: 50
                    },
                    myPerPageDropdown: [10, 20, 30, 40, 50]
                };

                this.searchQuery = {

                };
                this.updateResource();
            },

            saveParameterFilter() {
                localStorage.setItem(
                    "festivita_searchQuery",
                    JSON.stringify(this.searchQuery)
                );
                localStorage.setItem(
                    "festivita_serverParams",
                    JSON.stringify(this.serverParams)
                );
            },

            saveSearchFilter() { // salva parametri di ricerca
                localStorage.setItem('festivita_searchQuery', JSON.stringify(this.searchQuery));
            },

            getSearchFilter() { // prende parametri di ricerca
                return JSON.parse(localStorage.getItem('festivita_searchQuery'));
            },

            getParameterFilter() { // prende parametri di tabella
                return JSON.parse(localStorage.getItem('festivita_serverParams'));
            },

            onPerPageChange(params) { // risultati per pagina
                console.log('onPerPageChange');
                console.log(params);
                this.serverParams.pagination = params;
                this.updateResource();
            },

            onPageChange(params) { // risultati nel numero di pagina della paginazione (Es: pag 2 di 5)
                console.log('onPageChange');
                console.log(params);
                this.serverParams.pagination = params;
                this.updateResource();
            },

            onSortChange(params) { // ordinamento risultati per campo
                console.log('onSortChange');
                console.log(params[0]);
                this.serverParams.sort = params[0];
                this.updateResource();
            },

            async updateResource() {
                let self = this;
                self.rows = [];
                self.isLoading = true;

                var typeSort = "+";
                if (this.serverParams.sort.type == "desc") {
                    typeSort = "-";
                }

                this.saveParameterFilter();

                await axios({
                    method: "GET",
                    url: self.$url + "makexp",
                    headers: this.$config.axiosHeaders(),
                    params: {
                        keywords: self.searchQuery.searchTerm,
                        orderBy: typeSort + self.serverParams.sort.field,
                        page: self.serverParams.pagination.currentPage,
                        limit: self.serverParams.pagination.currentPerPage
                    }
                }).then(function (response) {
                    self.totalRecords = response.data.total;
                    self.rows = [];
                    var obj = response.data.data;
                    for (let entity of obj ) {
                        self.rows.push({
                            id: entity.event_id,
                            title: entity.title,
                            featured: entity.featured,
                            comune: entity.comune,
                            categoria: entity.categoria
                        });
                    }
                }).catch(function (error) {
                    self.$processError(error);
                }).finally(() => (
                    self.isLoading = false)
                );
            },
            saveEvent (id, category, featured) {
              let self = this;
                 axios({
                    method: "PUT",
                    url: self.$url + "makexp/" + id,
                    headers: this.$config.axiosHeaders(),
                    data: {
                        featured: featured,
                        category: category
                    }
                }).catch(function (error) {
                    self.$processError(error);
                }).finally(() => (
                    self.isLoading = false)
                );
            }

        } // methods
    };
</script>
